/**
 * @name downloadFile
 * @description Downloads an object as a
 * @param {string} exportObj
 * @param {string} exportName
 *
 * @returns {JSON} download json file
 */

export const downloadFile = (exportObj: any, exportName: string) => {
  let dataStr =
    'data:text/json;charset=utf-8,' +
    encodeURIComponent(JSON.stringify(exportObj))
  let downloadAnchorNode = document.createElement('a')
  downloadAnchorNode.setAttribute('href', dataStr)
  downloadAnchorNode.setAttribute('download', exportName + '.json')
  document.body.appendChild(downloadAnchorNode) // required for firefox
  downloadAnchorNode.click()
  downloadAnchorNode.remove()
}

export const downloadZipFile = () => {
  const path =
    'https://www.paypalobjects.com/ppdevdocs/Advanced_checkout_solution.zip'

  fetch(path).then((response) => {
    response.blob().then((blob) => {
      const fileUrl = window.URL.createObjectURL(blob)
      let alink = document.createElement('a')
      alink.href = fileUrl
      alink.download = 'Advanced checkout solution'
      document.body.appendChild(alink)
      alink.click()
      alink.remove()
    })
  })
}
